import { render, staticRenderFns } from "./index01.vue?vue&type=template&id=354a49d9&scoped=true&"
import script from "./index01.vue?vue&type=script&lang=js&"
export * from "./index01.vue?vue&type=script&lang=js&"
import style0 from "./index01.vue?vue&type=style&index=0&id=354a49d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a49d9",
  null
  
)

export default component.exports